import { WebParameterContext, WebResponesContext } from '../../model/common';
export class ServicesgridListXML {
  constructor(
  ) {

  }
  public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
    webcontext.RequestBody={};
    webcontext.RequestBody.Type=1;//复购提醒
    return webcontext;
  }

}